module.exports = __webpack_public_path__ + "static/media/retrato_8.6664f1fb.jpg";